<template>
  <div class="margin-top-five">
    <div class="settings-header">
      <h2>GPU settings</h2>
    </div>

    <v-checkbox
      label   = "Enable GPU decode"
      v-model = "enableGpuDecode"
      @change = "setEnableGpuDecode"
    >
    </v-checkbox>

    <v-select
      @change            = "updateGpuPreset(gpuPresetModel)"
      :items             = "gpuPresets"
      item-text          = "0"
      item-value         = "1"
      v-model            = "gpuPresetModel"
      label              = "Gpu Preset"
      append-outer-icon  = "mdi-delete"
      @click:append-outer = "removeGpuPreset"
    ></v-select>

  </div>
</template>

<script>
import {AllGpuPresets} from "@/services/encoding-service";
import {AllowedViews} from "@/services/allowed-views-service";

export default {
  name:  "GpuSettings",
  props: ['gpuDecode', 'connection', 'gpuPreset', 'uiAccess'],
  data:  function (){
    return {
      enableGpuDecode: false,
      gpuPresetModel:  null,
      gpuPresets:      AllGpuPresets,
      AllowedViews,
    }
  },
  mounted() {
    this.enableGpuDecode = this.gpuDecode;
    this.gpuPresetModel = this.gpuPreset;
  },
  methods: {
    setEnableGpuDecode(value){
      return this.connection
        .invoke('UpdateGpuDecode', value)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit('success', value === true ? 'enabled.' : 'disabled.')
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
    },
    updateGpuPreset(newGpuPreset) {
      return this.connection
        .invoke("UpdateGpuPreset", newGpuPreset)
        .then((response) => {
          if (response.resultKind === "Success") {
            const updated = response.entity;
            this.gpuPresetModel = updated.gpuPreset;
            this.$emit('encode', updated)
            this.$emit('success', 'Gpu Preset updated.')
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch(reason => {
          this.$emit("failure", reason);
        });
    },
    removeGpuPreset() {
      return this.connection
        .invoke("RemoveGpuPreset")
        .then((response) => {
          if (response.resultKind === "Success") {
            const updated = response.entity;
            this.gpuPresetModel = updated.gpuPreset;
            this.$emit('encode', updated)
            this.$emit('success', 'Gpu Preset removed.')
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch(reason => {
          this.$emit("failure", reason);
        });
    },
  }
}
</script>

<style scoped>

</style>